class Accordions {
    constructor(element) {
        Object.defineProperty(this, "element", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "content", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.element = element;
        const title = this.element.querySelector('.accordion-title');
        const content = this.element.querySelector('.accordion-content');
        if (!title) {
            throw new Error('Accordion title not found');
        }
        if (!content) {
            throw new Error('Accordion content not found');
        }
        this.title = title;
        this.content = content;
        this.title.addEventListener('click', this.toggleAccordion.bind(this));
    }
    toggleAccordion() {
        if (this.element.classList.contains('active')) {
            this.element.classList.remove('active');
            jQuery(this.content).stop().slideUp(200);
        }
        else {
            this.element.classList.add('active');
            jQuery(this.content).stop().slideDown(200);
        }
    }
}
export default function accordions() {
    const accordian = document.querySelectorAll('.single-accordion');
    for (const element of accordian) {
        new Accordions(element);
    }
}
